
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/categorie",
      function () {
        return require("private-next-pages/blog/categorie/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/categorie"])
      });
    }
  